import { render } from "./PersistentButton.vue?vue&type=template&id=d863c4ba&scoped=true&ts=true"
import script from "./PersistentButton.vue?vue&type=script&lang=ts"
export * from "./PersistentButton.vue?vue&type=script&lang=ts"

import "./PersistentButton.vue?vue&type=style&index=0&id=d863c4ba&lang=scss&scoped=true"

import exportComponent from "/builds/root/dev.front.widget/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d863c4ba"]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
